import { render, staticRenderFns } from "./HistopathologySliceBrowser.vue?vue&type=template&id=19355f90&scoped=true"
import script from "./HistopathologySliceBrowser.vue?vue&type=script&lang=js"
export * from "./HistopathologySliceBrowser.vue?vue&type=script&lang=js"
import style0 from "./HistopathologySliceBrowser.vue?vue&type=style&index=0&id=19355f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19355f90",
  null
  
)

export default component.exports